import type { LucideIcon } from 'lucide-react';
import { ChatComposerHero } from './ChatComposerHero';

type NewTabRoute = {
  id: string;
  path: string;
  title: string;
  subtitle?: string;
  status: string;
  icon: LucideIcon;
  requireAnyPermission?: string[];
};

// New-tab surface mirrors Home — both render the Claude-style chat
// composer, no Chat doc minted until the user submits.
export function NewTabPage(_props: { routes: NewTabRoute[] }) {
  return <ChatComposerHero />;
}
